import { FormattingKeys } from '../../../components/formattedString/FormattedString';

export const AuthFailureMessages = {
    CREDENTIALS_MISMATCH: `Sorry, we didn’t recognise those details. Please review and try again. If you think you've forgotten your password please ${FormattingKeys.FORGOTTEN_PASSWORD_LINK}.`,
    ACCOUNT_LOCKED: `Your account has been locked as there have been too many failed attempts to sign in. Please wait 15 minutes and try again. If you continue to have issues please contact us on ${FormattingKeys.TELEPHONE_NUMBER} to unlock your account.`,
    SESSION_EXPIRED: `Your session has expired due to inactivity. Please refresh this page to sign in.`,
};

export class AuthFailureError extends Error {}

export class CredentialsMismatchError extends AuthFailureError {
    public constructor() {
        super(AuthFailureMessages.CREDENTIALS_MISMATCH);
    }
}

export class AccountLockedError extends AuthFailureError {
    public constructor() {
        super(AuthFailureMessages.ACCOUNT_LOCKED);
    }
}

export class SessionExpiredError extends AuthFailureError {
    public constructor() {
        super(AuthFailureMessages.ACCOUNT_LOCKED);
    }
}

export class ServiceUnavailableError extends Error {}
